import { ReactNode } from "react";
import { surfaceContainerStyles } from "./SurfaceContainer.css";

/** Surface container – Default container color. Used for page backgrounds. Think of this as the ‘Floor’. */
const SurfaceContainer = ({ children }: { children: ReactNode }) => (
  <div className={surfaceContainerStyles}>{children}</div>
);

export default SurfaceContainer;
